import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext } from 'react';
import PunchCursor from 'images/place-punch-cursor.png';

const PlacePunchFooter: FC = () => {
  const { actions } = useContext(AppStoreContext);
  const { translate } = useTranslator(['buttons']);

  async function handlePlacePunchCancelClick() {
    actions.deleteInteractions('PlacePunch');
  }

  return (
    <>
      <style>
        {`
          .mapboxgl-canvas {
            cursor:url(${PunchCursor}) 10 10, auto !important;
          }
        `}
      </style>
      <div
        className="hrem-4p5 w100 bgd-white-2 px4 row justify-end items-center"
        style={{ position: 'sticky', bottom: '0' }}
      >
        <Button
          id="rfi-post-cancel"
          variant="tertiary"
          size="large"
          onClick={handlePlacePunchCancelClick}
          style={{ color: '#4d555c', fontSize: '16px', marginRight: '16px' }}
        >
          {translate('buttons:cancel')}
        </Button>
      </div>
    </>
  );
};

export default PlacePunchFooter;
